import { defineComponent as _defineComponent } from 'vue'
declare module 'vue/types/vue' {
  export interface Vue {
    IsolatedScrollContainer: ComponentWithProps<Props>;
  }
}

/**
 * `IsolatedScrollContainer` component properties.
 */
export interface Props {}


export default /*#__PURE__*/_defineComponent({
  __name: 'IsolatedScrollContainer',
  setup(__props: any) {



return { __sfc: true, }
}

})